import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SpecialOffer } from '../../app/models/SpecialOffer';
import { ModalDirective, Positioning, BsDatepickerConfig } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { SpecialOfferType } from '../../app/models/SpecialOfferType';
import { PoS } from '../../app/models/PoS';
import { CardType } from '../../app/models/CardType';
import { ProductCategory } from '../../app/models/ProductCategory';
import { Product } from '../../app/models/Product';
import { DateTime } from '../../app/models/DateTime';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { Zone } from '../../app/models/Zone';
import { TranslateService } from '@ngx-translate/core';
import { ProductsService } from '../../services/products.service';
import { AlertsHolder } from '../../app/models/AlertsHolder';

@Component({
  selector: 'page-special-offers',
  templateUrl: 'special-offers.html',
})
export class SpecialOffersPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('specialOfferModal')
  private specialOfferModal: ModalDirective;

  @ViewChild('specialOfferForm')
  private specialOfferForm: NgForm;

  private pageName: string = 'page-special-offers';

  private specialOffers: SpecialOffer[];
  private specialOfferTypes = SpecialOfferType;
  private posList: PoS[] = [];
  private zoneList: Zone[] = [];
  private cardTypes: CardType[] = [];
  private productCategories: ProductCategory[] = [];
  private products: Product[] = [];
  private service = null;
  private currentPos;
  private currentPosList: PoS[] = [];
  private currentOffer = new SpecialOffer();
  private currentCategory;
  private currentProductList: Product[] = [];
  private currentProduct;
  private currentCardType = new CardType();
  private currentZone;
  private activationDate = new DateTime();
  private expirationDate = new DateTime();
  public bsConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  private currentConfiguration: Config;
  private alertsHolder: AlertsHolder;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    private configService: ConfigService,
    private backendService: PaytronBackendService,
    private productsService: ProductsService
  ) {
    this.currentConfiguration = this.configService.getConfiguration();
    this.alertsHolder = new AlertsHolder(translate);
  }

  ngOnInit(): void {
    this.specialOffers = [];
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.bsConfig = this.currentConfiguration.datepickerConfig;
    this.loadPosList();
    this.loadZoneList();
    this.loadCardTypes();
    this.loadProducts();
    this.loadProductCategories();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getSpecialOffers();
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  private loadPosList() {
    this.backendService.getPoSList().subscribe(
      (posList) => {
        this.posList = posList;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadZoneList() {
    this.backendService.getZones().subscribe(
      (zones) => {
        this.zoneList = zones;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadCardTypes() {
    this.backendService.getCardTypes(this.service).subscribe(
      (cardTypes: CardType[]) => {
        this.cardTypes = cardTypes;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadProducts() {
    this.productsService.getProducts().subscribe(
      (products) => {
        this.products = products;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadProductCategories() {
    this.backendService.getProductCategories().subscribe(
      (categories) => {
        this.productCategories = categories;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getSpecialOffers() {
    this.backendService.getSpecialOffers().subscribe(
      (offers) => {
        this.specialOffers = offers;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addSpecialOffer() {
    this.currentOffer = new SpecialOffer();
    this.currentPos = new PoS();
    this.specialOfferForm.resetForm();
    this.activationDate.time = new Date(new Date().toDateString() + ' 00:00:00');
    this.expirationDate.time = new Date(new Date().toDateString() + ' 00:00:00');
    this.showSpecialOfferModal();
  }

  editSpecialOffer(offer: SpecialOffer) {
    this.currentOffer = offer;
    if (this.currentOffer.pointsOfSale && this.currentOffer.pointsOfSale.length && this.currentOffer.pointsOfSale[0]) {
      const pos: PoS = this.posList.find((value: PoS) => value.uuid == this.currentOffer.pointsOfSale[0].uuid);
      if (pos) {
        this.onZoneSelect(this.zoneList.find((value: Zone) => value.uuid == pos.zone.uuid));
      }
      this.onPosSelect(pos);
    } else if (this.currentOffer.zones && this.currentOffer.zones.length && this.currentOffer.zones[0]) {
      this.onZoneSelect(this.zoneList.find((value: Zone) => value.uuid == this.currentOffer.zones[0].uuid));
    } else {
      this.onPosSelect(null);
      this.onZoneSelect(null);
    }
    if (this.currentOffer.cardTypes && this.currentOffer.cardTypes.length && this.currentOffer.cardTypes[0]) {
      this.onCardTypeSelect(
        this.cardTypes.find((value: CardType) => value.uuid == this.currentOffer.cardTypes[0].uuid)
      );
    } else {
      this.onCardTypeSelect(null);
    }
    if (this.currentOffer.products && this.currentOffer.products.length && this.currentOffer.products[0]) {
      const product: Product = this.products.find((value: Product) => value.uuid == this.currentOffer.products[0].uuid);
      if (product) {
        this.onCategorySelect(
          this.productCategories.find((value: ProductCategory) => value.uuid == product.category.uuid)
        );
      }
      this.onProductSelect(product);
    } else if (
      this.currentOffer.productCategories &&
      this.currentOffer.productCategories.length &&
      this.currentOffer.productCategories[0]
    ) {
      this.onCategorySelect(
        this.productCategories.find(
          (value: ProductCategory) => value.uuid == this.currentOffer.productCategories[0].uuid
        )
      );
    } else {
      this.onProductSelect(null);
      this.onCategorySelect(null);
    }
    this.activationDate.setDate(this.currentOffer.startDate);
    this.expirationDate.setDate(this.currentOffer.endDate);
    this.showSpecialOfferModal();
  }

  submitSpecialOffer(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.setDates();
    this.backendService
      .saveOrUpdateSpecialOffer(this.currentOffer)
      .subscribe(
        (offer) => {
          this.closeSpecialOfferModal();
        },
        (err: HttpErrorResponse) => {
          let errorMessage;
          if (err.error.codeNumber === 'APP-028') {
            errorMessage = "Overlap another special offer forbidden";
          } else {
            errorMessage = 'Server error.';
          }
          this.alertsHolder.show(errorMessage, 'danger');
        }
      )
      .add(() => {
        btnEvent.disabled = false;
      });
  }

  setDates() {
    this.currentOffer.startDate = this.activationDate.getDate();
    this.currentOffer.endDate = this.expirationDate.getDate();
  }

  onPosSelect(pos) {
    this.currentPos = pos;
    if (pos) {
      this.currentOffer.pointsOfSale.splice(0, 1, this.currentPos);
      this.currentOffer.zones = [];
    } else {
      if (this.currentZone) {
        this.currentOffer.zones.splice(0, 1, this.currentZone);
      } else {
        this.currentOffer.zones = [];
      }
      this.currentOffer.pointsOfSale = [];
    }
  }

  onZoneSelect(zone) {
    this.currentZone = zone;
    this.onPosSelect(null);
    this.currentPosList = this.posList.filter((pos: PoS) => zone && pos.zone.uuid.match(zone.uuid));
  }

  onCardTypeSelect(cardType) {
    this.currentCardType = cardType;
    cardType ? this.currentOffer.cardTypes.splice(0, 1, cardType) : this.currentOffer.cardTypes.pop();
    this.currentOffer.appliesToEveryCardType = cardType === null;
  }

  onCategorySelect(category) {
    this.currentCategory = category;
    this.onProductSelect(null);
    this.currentProductList = this.products.filter(
      (value: Product) => category && value.category.uuid.match(category.uuid)
    );
  }

  onProductSelect(product) {
    this.currentProduct = product;
    if (product) {
      this.currentOffer.products.splice(0, 1, this.currentProduct);
      this.currentOffer.productCategories = [];
    } else {
      if (this.currentCategory) {
        this.currentOffer.productCategories.splice(0, 1, this.currentCategory);
      } else {
        this.currentOffer.productCategories = [];
      }
      this.currentOffer.products = [];
    }
  }

  deleteSpecialOffer() {
    this.backendService
      .deleteSpecialOffer(this.currentOffer)
      .subscribe(
        (data) => {
          this.getSpecialOffers();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  showConfirmModal(offer) {
    this.currentOffer = offer;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showSpecialOfferModal() {
    this.specialOfferModal.show();
  }

  closeSpecialOfferModal() {
    this.getSpecialOffers();
    this.specialOfferModal.hide();
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/special-offers/special-offers.ts